import { render, staticRenderFns } from "./PopLogoff.vue?vue&type=template&id=1964cb02&scoped=true&"
import script from "./PopLogoff.vue?vue&type=script&lang=js&"
export * from "./PopLogoff.vue?vue&type=script&lang=js&"
import style0 from "./PopLogoff.vue?vue&type=style&index=0&id=1964cb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1964cb02",
  null
  
)

export default component.exports